export const apiMiddleware = (store: any) => (next: any) => (action: any) => {
    next(action);
}